import { RootState } from '@app/index';

export const selectIsLoading = ({ stripe }: RootState) => stripe.isStripeLoading;
